import React from 'react';
import AppHeaderStyles from './AppHeader.module.css';

const CloseMenuIcon = ({ dataTestId }) => {
  const mainNavIconFillClass = AppHeaderStyles.mainNavIconFill;
  return (
    <svg
      data-testid={dataTestId}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xlinkHref="http://www.w3.org/1999/xlink"
      x="0"
      y="0"
      viewBox="0 0 22 22"
      style={{
        height: '1.8rem',
        width: '2.4rem',
        fill: '#3B3B3A',
      }}
      className={` ${mainNavIconFillClass}`}
    >
      <title>Close Main Navigation Button</title>
      <path
        className="st0"
        d="M13.8,11l7.4-7.4c0.8-0.8,0.8-2,0-2.8s-2-0.8-2.8,0L11,8.2L3.6,0.8C2.9,0,1.6,0,0.8,0.8s-0.8,2,0,2.8L8.2,11	l-7.4,7.4c-0.8,0.8-0.8,2,0,2.8s2,0.8,2.8,0l7.4-7.4l7.4,7.4c0.8,0.8,2,0.8,2.8,0s0.8-2,0-2.8L13.8,11z"
      />
    </svg>
  );
};

export default CloseMenuIcon;
